import type { CategoryAttribute } from '../types/category';

function optionsRecordFromAttribute(
  attribute: Pick<CategoryAttribute, 'options'>
): Record<string, string[]> | null {
  if (
    typeof attribute.options === 'object' &&
    attribute.options !== null &&
    !Array.isArray(attribute.options)
  ) {
    return attribute.options as Record<string, string[]>;
  }
  return null;
}

export function resolveConditionalDependsOnValue(
  attributeKey: string,
  attribute: Pick<CategoryAttribute, 'depends_on' | 'options'>,
  dependentValues: Record<string, string>
): string {
  const optionsRecord = optionsRecordFromAttribute(attribute);
  if (!optionsRecord) return '';

  if (attribute.depends_on) {
    const parentValue = dependentValues[attribute.depends_on];
    if (parentValue && optionsRecord[parentValue]) {
      return parentValue;
    }
    return parentValue || '';
  }

  if (attributeKey === 'size' || attributeKey === 'subtype') {
    const v = dependentValues.category_type || dependentValues.clothing_type || '';
    return v && optionsRecord[v] ? v : v;
  }

  if (attributeKey === 'model' || attributeKey === 'modele') {
    const v = dependentValues.brand || dependentValues.marque || '';
    return v && optionsRecord[v] ? v : v;
  }

  for (const depValue of Object.values(dependentValues)) {
    if (depValue && optionsRecord[depValue]) {
      return depValue;
    }
  }

  return '';
}

export function resolveConditionalSelectLabel(
  attribute: Pick<CategoryAttribute, 'label' | 'conditional_labels'>,
  dependsOnValue: string
): string {
  if (dependsOnValue && attribute.conditional_labels?.[dependsOnValue]) {
    return attribute.conditional_labels[dependsOnValue];
  }
  return attribute.label;
}

export function resolveConditionalSelectOptions(
  attributeKey: string,
  attribute: CategoryAttribute,
  dependentValues: Record<string, string>
): string[] {
  const optionsRecord = optionsRecordFromAttribute(attribute);
  if (!optionsRecord) return [];

  const dependsOnValue = resolveConditionalDependsOnValue(attributeKey, attribute, dependentValues);
  if (dependsOnValue && optionsRecord[dependsOnValue]) {
    return optionsRecord[dependsOnValue];
  }
  return [];
}
